
  // 分转成元，角转元...
  //小数位为0直接显示整数，有一位显示一位，有多位显示两位，isFix是否保留位数
  let filterPrice = function(data, i = 2,isFix = true) {
    if (data && !isNaN(data)) {
      var yuan = Number(data / Math.pow(10, i));
      var fixed0 = yuan.toFixed(0);
      var fixed1 = yuan.toFixed(1);
      var fixed2 = yuan.toFixed(2);
      if(!isFix) {
        return yuan;
      }
      if (
        Number(fixed0) == Number(fixed1) &&
        Number(fixed1) == Number(fixed2)
      ) {
        return fixed0;
      } else if (
        Number(fixed0) != Number(fixed1) &&
        Number(fixed1) == Number(fixed2)
      ) {
        return fixed1;
      } else {
        return fixed2;
      }
    } else {
      return 0;
    }
  }
  // 元转成分，元转角
  let filterPriceToFen = function(data, i = 2) {
    if (data && !isNaN(data)) {
      return Number(data * Math.pow(10, i)).toFixed(0);
    } else {
      return 0;
    }
  }
  // 获取价格整数部分
  let getPriceNum = function(num) {
    return isNaN(num) ? '' : Math.floor(num / 100);
  }

  // 获取价格小数部分
  let getPriceDecimals = function(num,noZero) {
    if (isNaN(num)) {
      return '';
    }
    var decimals = (num / 100).toString().split('.');
    if (decimals[0] && !decimals[1] && noZero) {
      return '';
    } else if (decimals[0] && !decimals[1]) {
      return '.00';
    } else if (decimals[0] && decimals[1]) {
      return '.' + decimals[1];
    } else {
      return '';
    }
  }
  /**
   * 处理数字,规则
   * 9999以下显示原数字
   * 9999以上显示xxxw
   */
  let filterNum = function(num, tag = 'w') {
    if (isNaN(num)) {
      return '';
    }
    if (num < 10000) {
      return num;
    } else {
      var result = Math.floor(num / 100) / 100 + tag;
      return result;
    }
  }

   /**
   * 将日期格式化成指定格式的字符串
   * @param date 要格式化的日期，不传时默认当前时间，也可以是一个时间戳
   * @param fmt 目标字符串格式，支持的字符有：y,M,d,q,w,H,h,m,S，默认：yyyy-MM-dd HH:mm:ss
   * @returns 返回格式化后的日期字符串
   */
  let formatDate = function (date, fmt) {
    date = new Date(date.toString().replace(RegExp("-", "g"), "/"));
    date = date === undefined ? new Date() : date;
    date = typeof date == "number" ? new Date(date) : date;
    fmt = fmt || "yyyy-MM-dd HH:mm:ss";
    var obj = {
      y: date.getFullYear(), // 年份，注意必须用getFullYear
      M: date.getMonth() + 1, // 月份，注意是从0-11
      d: date.getDate(), // 日期
      q: Math.floor((date.getMonth() + 3) / 3), // 季度
      w: date.getDay(), // 星期，注意是0-6
      H: date.getHours(), // 24小时制
      h: date.getHours() % 12 == 0 ? 12 : date.getHours() % 12, // 12小时制
      m: date.getMinutes(), // 分钟
      s: date.getSeconds(), // 秒
      S: date.getMilliseconds() // 毫秒
    };
    var week = ["天", "一", "二", "三", "四", "五", "六"];
    var objKeys = ['y', "M", "d", "q", "w", "H", "h", "m", "s", "S"];
    for (var i = 0; i < objKeys.length; i++) {
      var key = objKeys[i];
      fmt = fmt.replace(RegExp(key + "+", "g"), function(m) {
        var val = obj[key] + "";
        if (key == "w") return (m.length > 2 ? "星期" : "周") + week[val];
        var len = val.length;
        for (var j = 0; j < m.length - len; j++)
          val = "0" + val;
        return m.length == 1 ? val : val.substring(val.length - m.length);
      });
    }
    return fmt;
  }
  /**
   * 时间的友好处理
   * 不同年   2018-03-25
   * 不同月   3-25
   * 不同天   {
   *          < 7 x天前
   *          < 30 3-25
   *         }
   * 不同小时 {
   *          < 10 x小时前
   *          < 24 hh:mm
   *         }
   * 不同分钟 {
   *          < 1 刚刚
   *          < 60 xx分前
   *         }
   *
   *
   * @param date 时间,IOS需要过滤'2018-03-25 10:58:23'这样的类型,不识别
   */
  let formatDateFriendly = function(dateStr) {
    if (!dateStr) {
      return '';
    }
    var tempDate = new Date(dateStr.replace('-', '/').replace('-', '/'));
    var tempTime = tempDate.getTime();
    var tempYear = tempDate.getFullYear();
    var tempMonth = tempDate.getMonth() + 1;
    var tempDay = tempDate.getDate();

    var nowDate = new Date();
    var nowTime = nowDate.getTime();
    var nowYear = nowDate.getFullYear();
    var nowMonth = nowDate.getMonth() + 1;
    var nowDay = nowDate.getDate();

    if (nowTime < tempTime) {
      return '';
    }
    if (tempYear < nowYear) {
      return tempYear + '-' + tempMonth + '-' + tempDay;
    }
    //不同月
    if (tempMonth < nowMonth) {
      return tempMonth + '-' + tempDay;
    }
    //不同天
    if (tempDay < nowDay) {
      if (nowDay - tempDay < 7) {
        return nowDay - tempDay + '天前';
      } else {
        return tempMonth + '月' + tempDay + '日';
      }
    }
    var subHour = (nowTime - tempTime) / (1000 * 60 * 60);
    var subMin = (nowTime - tempTime) / (1000 * 60);

    if (subHour > 1) {
      return subHour.toFixed(0) + '小时前';
    } else if (subHour < 1 && subMin > 1) {
      return subMin.toFixed(0) + '分钟前';
    } else {
      return '刚刚';
    }
  }

  let filterNaN = function(num) {
    return isNaN(num) ? '' : num;
  }
  /**
   * 格式化分销名称
   */
  let starUserLevel = function(l) {
    var n = '';
    if (typeof l == 'object') {
      if (l.is_celebrity || l.is_star) {
        n = '星选达人';
      } else if (l.is_tutor) {
        n = '星选导师';
      } else if (l.is_promoter) {
        n = '推广员';
      }else if (l.is_vip) {
        n = '星选会员';
      }
    } else {
      switch (l) {
        case 10:
          n = '星选会员';
          break;
        case 20:
          n = '星选达人';
          break;
        case 30:
          n = '星选导师';
          break;
      }
    }
    return n;
  }

  // 数量超出处理
  let numFloor = function (num,max) {
    num = num || 0;
    max = max || 99;
    if (num>max) {
      return max + '+';
    }
    return Math.min(num, max);
  }

  // 百分比和钱的处理 percent/10000*amount
  let percentWithAmount = function (percent, amount) {
    amount = percent * amount / 10000;
    return amount;
  }

  let getDateSecond = function(time1,time2){
    if(time1&&time2){
      let difference = Math.abs(new Date(time1).getTime() / 1000 - new Date(time2).getTime() / 1000);
      if(difference>=7*24*60*60){
        return true;
      }else{
        return false;
      }
    }

  }

  // oss图片处理
  let ossImgOptimize = function (url='',resize='750', quality='80') {
    let ossUrl = url+'?x-oss-process=image/resize,w_'+resize+'/quality,Q_'+quality;
    return ossUrl;
  }

  let getSource = function (source) {
    switch (source) {
      case 'mokuaitv': 
        return '魔筷星选';
      case 'penguin':
        return '企鹅小店'
      case 'wdzb':
        return '无敌主播'
    }
  }

  /**
   * 是否退款中 refund_status 维权状态
   */
  let isRefunding = function(status){
    var refundStatus = [1,2,5,6];
    return refundStatus.indexOf(status * 1) > -1 ? '退款中':'';
  }

  // 订单状态文案
  let getOrderText = function (status,formFlag){
    if (formFlag > 1) {
      switch (formFlag) {
        case 2:
          return '拼团中';
        case 3:
          return '拼团失败-退款中';
        case 4:
          return '退款成功';
      }
    } else {
      switch (status) {
        case 1:
          return '退款中';
        case 2:
          return '退款中';
        case 3:
          return '拒绝退款';
        case 4:
          return '退款完成';
        case 5:
          return '退款失败';
        case 6:
          return '退货中';
        case 7:
          return '取消维权';
        //
        case 10:
          return '待付款';
        case 20:
          return '已取消';
        case 21:
          return '已取消';
        case 22:
          return '已取消';
        case 23:
          return '已取消';
        case 30:
          return '待发货';
        case 40:
          return '已发货';
        case 50:
          return '已收货';
        case 60:
          return '已评价';
        case 70:
          return '退款中';
        case 71:
          return '退款中';
        case 90:
          return '已完成';
        case 80:
          return '已关闭';
        default:
          return '';
      }
    }
  }
  // 订单详情头部状态
  let orderDetailStatus = function (order,placeContent) {
    placeContent = placeContent || "";
    var info = {
      title: '',
      desc: '',
      status: 0,
    }
    if (!order || !order.order_status) return info;
    var type = order.order_status || 10;
    switch (type) {
      case 10:
        info.title = '待付款';
        info.desc = '30分钟内付款，超时订单将自动关闭';
        info.status = 1;
        break;
      case 20:
        info.title = '已取消';
        info.desc = '买家已取消';
        info.status = 2;
        break;
      case 21:
        info.title = '已取消';
        info.desc = '卖家已取消';
        info.status = 2;
        break;
      case 23:
        info.title = '已取消';
        info.desc = '超时未支付订单取消';
        info.status = 2;
        break;
      case 30:
        info.title = '待发货';
        info.desc = '物流信息：等待卖家发货';
        info.status = 1;
        break;
      case 40:
        info.title = '待收货';
        info.desc = '卖家已发货，还剩'+ placeContent +' 自动确认收货';
        info.status = 1;
        break;
      case 50:
        info.title = '已收货';
        info.desc = '希望这次购物您能满意，您满意是我们的动力';
        info.status = 2;
        break;
      case 80:
        info.title = '已关闭';
        info.desc = '交易已关闭';
        info.status = 2;
        break;
      case 90:
        info.title = '已完成';
        info.desc = '交易已完成';
        info.status = 2;
        break;

      default:
        break;
    }
    return info;
  }
  export {
    filterPrice,
    filterPriceToFen,
    getPriceNum,
    getPriceDecimals,
    filterNum,
    formatDate,
    formatDateFriendly,
    filterNaN,
    starUserLevel,
    numFloor,
    percentWithAmount,
    getDateSecond,
    getOrderText,
    ossImgOptimize,
    isRefunding,
    getSource,
    orderDetailStatus,
  }
